import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const DialogComponent = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
  cancelText,
  okText,
}) => {
  const handleOnCloseClick = (event, reason) => {
    if (reason === "backdropClick") return;
    if (onClose) onClose();
  };

  return (
    <Dialog open={open} onClose={handleOnCloseClick}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {cancelText ? cancelText : onConfirm ? "Cancel" : "Ok"}
        </Button>
        {onConfirm && (
          <Button
            onClick={() => {
              onConfirm && onConfirm();
              onClose();
            }}
            color="primary"
            autoFocus
          >
            {okText || "Confirm"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DialogComponent;
